import React from "react"
import {
  Box, Flex, Stack, Text,
} from "@chakra-ui/react"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { DioboxEvent, AccountUser } from "sharedTypes"
import TextField from "components/ReactHookForm/TextField"
import SubjectLineEditor from "components/ReactHookForm/SubjectLineEditor"
import RadioButtons from "components/ReactHookForm/RadioButtons"
import { hasValidCustomDomain } from "utilities/strings"
import { replyToEmailOptions } from "utilities/objects"
import SimpleBar from "simplebar-react"
import { Control, useController } from "react-hook-form"
import { EmailFormValues } from ".."

type Props<T extends EmailFormValues> = {
  event: DioboxEvent,
  control: Control<T, object>
  accountUsers?: AccountUser[],

}
const Setup = ({ event, accountUsers, control }: Props<EmailFormValues>) => {
  const replyToOptions = replyToEmailOptions(event.users, accountUsers)

  const { field: { value: title } } = useController({ name: "title" as const, control })

  const titleIsValid = title.length > 0

  return (
    <Box as={SimpleBar} width="100%" height="full">
      <Stack w={800} spacing={6} p={8} m="auto">
        <TextField
          name="title"
          control={control}
          variant="outline"
          label="Email Name"
          labelSize="lg"
          helperText="This title is for internal use and won't be visible to your guests."
          errorMessage="Email Name is required"
          error={!titleIsValid}
        />
        <SubjectLineEditor
          name="subject"
          control={control}
          event={event}
          label="Subject Line"
          labelSize="lg"
          helperText="Use merge fields to personalize the subject for each guest."
        />
        <TextField
          name="from"
          control={control}
          variant="outline"
          label="Sender Name"
          labelSize="lg"
        />
        {hasValidCustomDomain(event) ? (
          <TextField
            name="fromMailbox"
            control={control}
            variant="outline"
            label="Sender Email"
            labelSize="lg"
            rightElement={`@${event.customDomain?.domain}`}
          />
        ) : (
          <>
            <TextField
              disabled
              name="senderEmail"
              control={control}
              variant="outline"
              label="Sender Email"
              labelSize="lg"
            />
            {replyToOptions.length > 0 && (
            <RadioButtons
              name="replyTo"
              control={control}
              label='"Reply to" Address'
              labelSize="lg"
              options={replyToOptions}
            />
            )}
            <Flex>
              <Text w="100%">
                All emails will be sent from events@diobox.com, but you can select a “reply to”
                address, so that if anyone replies, their messages will still get delivered to
                you. To add a new “reply-to” address, invite a new team member and have them
                verify their email address.
              </Text>
            </Flex>
          </>
        )}
        {!event.whiteLabel
          && (
            <UpgradeAlert
              text="Upgrade to the Corporate Subscription to send emails from your company domain"
            />
          )}
      </Stack>
    </Box>
  )
}

export default Setup
